import { Link } from "react-router-dom";
import { ArrowRightShort } from "react-bootstrap-icons";
import "./ForwardButton.scss";

interface ForwardButtonProps {
  linkTo: string;
}

export default function ForwardButton(props: ForwardButtonProps) {
  return (
    <Link to={props.linkTo}>
      <ArrowRightShort className="forward-button text-primary" />
    </Link>
  );
}
